(function () {

    console.clear();

    console.log("================================");
    console.log("VORYNEX Blueprint V2");
    console.log("Bootstrapping...");
    console.log("================================");

    if (window.VORYNEX) {
        console.warn("Blueprint already initialized.");
        return;
    }

    window.VORYNEX = window.VORYNEX || {};

    window.VORYNEX.version = "2.0.0";

    window.VORYNEX.modules = window.VORYNEX.modules || {};

    window.VORYNEX.state = window.VORYNEX.state || {};

    window.VORYNEX.config = window.VORYNEX.config || {};

    window.VORYNEX.utils = window.VORYNEX.utils || {};

    window.VORYNEX.api = window.VORYNEX.api || {};

    console.log(window.VORYNEX);

    console.log("Global namespace created.");

})();